import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function ThankYou() {
  const { t, i18n } = useTranslation();
  // Force Croatian for this page
  React.useEffect(() => {
    const prev = i18n.language;
    if (prev !== 'hr') i18n.changeLanguage('hr');
    return () => {};
  }, [i18n]);

  return (
    <main className="aq-thanks">
      <div className="aq-container aq-thanks__inner">
        <div className="aq-thanks__mark" aria-hidden="true">
          <svg viewBox="0 0 64 64" width="64" height="64">
            <circle cx="32" cy="32" r="30" fill="none" stroke="#B8623A" strokeWidth="2" />
            <path d="M20 33 L29 42 L45 24" fill="none" stroke="#B8623A" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
        <span className="aq-eyebrow">Aurelqen</span>
        <h1 className="aq-thanks__title">{t('thank_you.title')}</h1>
        <p className="aq-thanks__lede">{t('thank_you.lede')}</p>
        <p className="aq-thanks__note">{t('thank_you.note')}</p>
        <Link to="/" className="aq-btn aq-btn--primary aq-thanks__btn" data-testid="thanks-home">
          {t('thank_you.back_home')}
        </Link>
      </div>
    </main>
  );
}
